function BasePageTransition() {
    body.imagesLoaded({
        background: true
    }).always(function () {
        pageTransition.entered = true;
        pageTransition.enter(function () {
            $(window).trigger('transitionDone');
        });
    });
}